(() => {
  if (window.MybeCartDrawerActionsV15) return;
  window.MybeCartDrawerActionsV15 = true;

  const rootUrl = window.Shopify?.routes?.root || '/';

  const updateStockLimit = scope => {
    (scope || document).querySelectorAll('#CartDrawer .mybe-cart-stepper, body.template-cart .mybe-cart-stepper').forEach(stepper => {
      const input = stepper.querySelector('input[name="updates[]"]');
      const plus = stepper.querySelector('button[name="plus"]');
      if (!input || !plus) return;
      const limitRaw = input.dataset.stockLimit;
      if (limitRaw === undefined || limitRaw === '') return;
      const limit = Number(limitRaw);
      const quantity = Math.max(0, Number(input.value || 0));
      const atLimit = Number.isFinite(limit) && quantity >= limit;
      plus.disabled = atLimit;
      plus.setAttribute('aria-disabled', atLimit ? 'true' : 'false');
      plus.classList.toggle('is-stock-limit', atLimit);
      plus.setAttribute('aria-label', atLimit ? 'Maximum available quantity reached' : 'Increase quantity');
    });
  };

  const updateMinusGlyphs = scope => {
    (scope || document).querySelectorAll('#CartDrawer .mybe-cart-stepper, body.template-cart .mybe-cart-stepper').forEach(stepper => {
      const input = stepper.querySelector('input[name="updates[]"]');
      const minus = stepper.querySelector('[data-mybe-drawer-minus]');
      if (!input || !minus) return;

      const quantity = Math.max(0, Number(input.value || 0));
      const state = quantity <= 1 ? 'one' : 'multiple';
      minus.dataset.qtyState = state;
      minus.setAttribute('aria-label', state === 'one' ? 'Remove item' : 'Decrease quantity');
    });
  };

  // Keep the + state synchronized with the current quantity, including native stepper updates.
  document.addEventListener('input', event => {
    if (!event.target.matches('#CartDrawer .mybe-cart-stepper input[name="updates[]"], body.template-cart .mybe-cart-stepper input[name="updates[]"]')) return;
    updateStockLimit(event.target.closest('.mybe-cart-stepper'));
  }, true);

  document.addEventListener('change', event => {
    if (!event.target.matches('#CartDrawer .mybe-cart-stepper input[name="updates[]"], body.template-cart .mybe-cart-stepper input[name="updates[]"]')) return;
    updateStockLimit(event.target.closest('.mybe-cart-stepper'));
  }, true);

  // Capture phase prevents a capped + from reaching the theme's quantity handler.
  document.addEventListener('click', event => {
    const plus = event.target.closest('#CartDrawer .mybe-cart-stepper button[name="plus"], body.template-cart .mybe-cart-stepper button[name="plus"]');
    if (!plus) return;
    const stepper = plus.closest('.mybe-cart-stepper');
    const input = stepper?.querySelector('input[name="updates[]"]');
    if (!input || input.dataset.stockLimit === undefined) return;
    const limit = Number(input.dataset.stockLimit);
    if (Number.isFinite(limit) && Number(input.value || 0) >= limit) {
      event.preventDefault();
      event.stopImmediatePropagation();
      updateStockLimit(stepper);
    }
  }, true);

  // Update the left control after a quantity button or manual input changes.
  document.addEventListener('change', event => {
    if (!event.target.matches('#CartDrawer .mybe-cart-stepper input[name="updates[]"], body.template-cart .mybe-cart-stepper input[name="updates[]"]')) return;
    const stepper = event.target.closest('.mybe-cart-stepper');
    const minus = stepper?.querySelector('[data-mybe-drawer-minus]');
    if (!minus) return;
    const state = Number(event.target.value || 0) <= 1 ? 'one' : 'multiple';
    minus.dataset.qtyState = state;
    minus.setAttribute('aria-label', state === 'one' ? 'Remove item' : 'Decrease quantity');
  }, true);

  const clearCart = async button => {
    if (button.dataset.busy === 'true') return;
    button.dataset.busy = 'true';
    window.MybeCartClearing = true;
    window.MybeCardQuickQty?.cancelPending?.();
    button.disabled = true;
    button.classList.add('is-clearing');

    // Match the instant per-item experience for Clear Cart as well. Keep the
    // drawer and its footer in place while Shopify applies the mutation.
    const drawerItems = document.querySelector('#CartDrawer cart-items');
    drawerItems?.querySelectorAll('.horizontal-product').forEach(row => {
      row.classList.add('mybe-quantity-pending-remove');
    });
    drawerItems?.updateOptimisticEmptyState?.();
    document.querySelectorAll('cart-count').forEach(node => {
      node.textContent = '0';
      node.hidden = true;
    });
    document.dispatchEvent(new CustomEvent('mybe:cart-optimistic', {
      detail: {item_count:0,total_price:0,direction:'removed',currency:window.MybeCartWriteQueue?.lastCart?.currency || 'USD'}
    }));

    const execute = async () => {
      const clearResponse = await fetch(`${rootUrl}cart/clear.js`, {
        method:'POST',
        headers:{Accept:'application/json'}
      });
      const clearResult = await clearResponse.json();
      if (!clearResponse.ok || clearResult.status) {
        throw new Error(clearResult.description || clearResult.message || 'Unable to clear cart');
      }

      const cartResponse = await fetch(`${rootUrl}cart.js`, {
        headers:{Accept:'application/json'},
        cache:'no-store'
      });
      const cart = await cartResponse.json();
      if (!cartResponse.ok || !Array.isArray(cart.items)) {
        throw new Error(cart.description || 'Unable to reload cart');
      }

      // Include fresh drawer HTML so Shopify's native cart subscribers replace the
      // item list, empty state, counters and footer from one consistent snapshot.
      const drawer = document.querySelector('cart-drawer[data-section-id]');
      if (drawer?.dataset.sectionId) {
        const sectionId = drawer.dataset.sectionId;
        try {
          const sectionResponse = await fetch(`${rootUrl}?section_id=${encodeURIComponent(sectionId)}`, {
            headers:{Accept:'text/html'},
            cache:'no-store'
          });
          if (sectionResponse.ok) {
            cart.sections = cart.sections || {};
            cart.sections[sectionId] = await sectionResponse.text();
          }
        } catch (error) {
          console.warn('[Mybe clear cart] Drawer section refresh failed',error);
        }
      }

      if (window.MybeCartWriteQueue) window.MybeCartWriteQueue.lastCart = cart;

      if (window.theme?.pubsub?.publish && window.theme?.pubsub?.PUB_SUB_EVENTS?.cartUpdate) {
        window.theme.pubsub.publish(window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
          source:'mybe-clear-cart',
          cart
        });
      } else {
        document.dispatchEvent(new CustomEvent('cart:refresh',{detail:{open:false}}));
      }

      document.dispatchEvent(new CustomEvent('cart:updated',{
        detail:{cart,source:'mybe-clear-cart'}
      }));
      document.dispatchEvent(new CustomEvent('mybe:cart-confirmed',{
        detail:{cart,direction:'removed'}
      }));
      button.disabled = false;
      button.dataset.busy = 'false';
      button.classList.remove('is-clearing');
      button.setAttribute('aria-label','Clear cart');
      return cart;
    };

    try {
      if (window.MybeCartWriteQueue) await window.MybeCartWriteQueue.run(execute);
      else await execute();
      window.MybeCartClearing = false;
    } catch (error) {
      window.MybeCartClearing = false;
      console.error('[Mybe clear cart]',error);

      // Restore the latest server truth and resume any drawer quantity updates that
      // were paused while the clear request was being attempted.
      try {
        const recoveryResponse = await fetch(`${rootUrl}cart.js`, {
          headers:{Accept:'application/json'}, cache:'no-store'
        });
        const recoveryCart = await recoveryResponse.json();
        if (recoveryResponse.ok && Array.isArray(recoveryCart.items)) {
          if (window.MybeCartWriteQueue) window.MybeCartWriteQueue.lastCart = recoveryCart;
          if (window.theme?.pubsub?.publish && window.theme?.pubsub?.PUB_SUB_EVENTS?.cartUpdate) {
            window.theme.pubsub.publish(window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
              source:'mybe-clear-cart-recovery',
              cart:recoveryCart
            });
          }
          document.dispatchEvent(new CustomEvent('cart:updated', {
            detail:{cart:recoveryCart,source:'mybe-clear-cart-recovery'}
          }));
        }
      } catch (recoveryError) {
        console.warn('[Mybe clear cart] Recovery failed',recoveryError);
      }

      // A rejected clear must not leave the optimistic empty placeholder stuck.
      drawerItems?.querySelectorAll('.mybe-quantity-pending-remove').forEach(row => {
        row.classList.remove('mybe-quantity-pending-remove');
      });
      drawerItems?.updateOptimisticEmptyState?.();

      document.querySelectorAll('cart-items').forEach(element => {
        element.processQuantityQueue?.();
      });
      button.disabled = false;
      button.classList.remove('is-clearing');
      button.dataset.busy = 'false';
      button.setAttribute('aria-label','Clear cart');
    }
  };

  document.addEventListener('click',event => {
    const button = event.target.closest('[data-mybe-clear-cart]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    clearCart(button);
  });

  // Footer Close button: use the theme's native drawer lifecycle.
  // CartDrawer.show() captures the page scroll position and CartDrawer.afterHide()
  // restores it after the theme has released the modal scroll lock.
  document.addEventListener('click', event => {
    const target = event.target;
    const closeButton = target instanceof Element ? target.closest('[data-mybe-close-cart]') : null;
    if (!closeButton) return;

    event.preventDefault();
    event.stopPropagation();

    const drawer = closeButton.closest('cart-drawer#CartDrawer, #CartDrawer');
    if (drawer && typeof drawer.hide === 'function') drawer.hide();
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded',() => { updateMinusGlyphs(); updateStockLimit(); },{once:true});
  } else {
    updateMinusGlyphs();
    updateStockLimit();
  }

  const stockObserver = new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node =>
      node.nodeType === 1 && (node.matches?.('.mybe-cart-stepper, cart-items, #MiniCart') ||
        node.querySelector?.('.mybe-cart-stepper'))))) {
      updateMinusGlyphs();
      updateStockLimit();
    }
  });
  stockObserver.observe(document.documentElement, {subtree:true, childList:true});
})();
